import React from 'react';
import Login from './pages/login';
import Home from './pages/home';
import Users from './pages/users';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/router/privateRoute';


const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route element={<PrivateRoute />}>
        <Route path="/home" element={<Home/>} />
        <Route path="/users" element={<Users/>} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;